'use client';

import { HeartIcon } from '@/components/icons';
import { Badge, Button } from '@heroui/react';

type LikeButtonLayoutProps = {
	liked: boolean;
	disabled: boolean;
	likeCount: number;
	isPending?: boolean;
	onToggle: () => void;
};

export const LikeButtonLayout = ({
	liked,
	disabled,
	likeCount,
	isPending,
	onToggle,
}: LikeButtonLayoutProps) => {
	return (
		<Badge
			content={likeCount}
			isInvisible={!likeCount}
			color="primary"
			placement="bottom-right"
			shape="circle"
			className="-translate-x-0"
		>
			<Button
				isIconOnly
				isDisabled={disabled}
				isLoading={isPending}
				className="text-default-900/60 data-[hover]:bg-foreground/10"
				radius="full"
				variant="light"
				onPress={onToggle}
			>
				<HeartIcon
					className={liked ? "[&>path]:stroke-transparent" : ""}
					fill={liked ? "currentColor" : "none"}
				/>
			</Button>
		</Badge>
	);
};
